import MDTypography from "components/MDTypography";

function CTLListDefaultCell({ value = [], suffix }) {
  const displayValue = Array.isArray(value)
    ? value.join(", ")
    : String(value || "");

  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">
      {displayValue}
      {suffix && (
        <MDTypography variant="caption" fontWeight="medium" color="secondary">
          &nbsp;&nbsp;{suffix}
        </MDTypography>
      )}
    </MDTypography>
  );
}

CTLListDefaultCell.defaultProps = {
  suffix: "",
};

export default CTLListDefaultCell;
